module.exports = __webpack_public_path__ + "static/media/technical-coffee.59dc82a5.png";